import { useSiteContent } from "@/context/SiteContentContext";
import { buildWhatsAppLink } from "@/lib/cms";

export default function WhatsAppButton() {
  const { settings } = useSiteContent();
  const number = String(settings.whatsapp_number || "");
  const message = String(settings.whatsapp_message || "");

  return (
    <a
      href={buildWhatsAppLink(number, message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-background-50 shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform cursor-pointer group"
    >
      <i className="ri-whatsapp-line text-3xl md:text-4xl" />
      <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-accent-500 rounded-full border-2 border-background-50 glow-pulse" />
    </a>
  );
}